import React from 'react';

const Checkbox = ({ checked, onChange, name, label, style }) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={onChange}
                style={{
                    width: '18px',
                    height: '18px',
                    cursor: 'pointer',
                    accentColor: '#4A90E2',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    ...style,
                }}
            />
            {label && <label style={{ fontSize: '16px', color: '#333' }}>{label}</label>}
        </div>
    );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components-new/Checkbox.jsx